"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.trackFeedbackSurveyClick = exports.trackLearnMoreClick = exports.trackOptAction = exports.trackOptView = exports.cloneTracker = exports.emptyTracker = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _events = _interopRequireDefault(require("ui-addon-opt/events.yaml"));

var _OptState = require("ui-addon-opt/state/OptState");

var _ACTIONS;

var OPTIN_INTERACTION = 'optin-interaction';
var OPTIN_VIEW = 'optin-view';
var LEARN_MORE_CLICK = 'learnMoreClick';
var FEEDBACK_PROVIDED = 'feedbackProvided';
var OPTED_IN = 'opted in';
var OPTED_OUT = 'opted out';
var REJECTED = 'dismissed';
var FEEDBACK_CLICKED = 'clicked to submit feedback';
var ARTICLE_CLICKED = 'clicked to view article';
var ACTIONS = (_ACTIONS = {}, (0, _defineProperty2.default)(_ACTIONS, FEEDBACK_PROVIDED, FEEDBACK_CLICKED), (0, _defineProperty2.default)(_ACTIONS, LEARN_MORE_CLICK, ARTICLE_CLICKED), (0, _defineProperty2.default)(_ACTIONS, _OptState.OPT_CHOICE_HUB_OPT_IN, OPTED_IN), (0, _defineProperty2.default)(_ACTIONS, _OptState.OPT_CHOICE_HUB_OPT_OUT, OPTED_OUT), (0, _defineProperty2.default)(_ACTIONS, _OptState.OPT_CHOICE_REJECT, REJECTED), (0, _defineProperty2.default)(_ACTIONS, _OptState.OPT_CHOICE_USER_OPT_IN, OPTED_IN), (0, _defineProperty2.default)(_ACTIONS, _OptState.OPT_CHOICE_USER_OPT_OUT, OPTED_OUT), _ACTIONS);
var emptyTracker = {
  clone: function clone() {
    return emptyTracker;
  },
  track: function track() {}
};
exports.emptyTracker = emptyTracker;

var cloneTracker = function cloneTracker(tracker) {
  return {
    standard: tracker.clone({
      events: _events.default
    }),
    immediate: tracker.clone({
      events: _events.default,
      isBeforeUnload: true
    })
  };
};

exports.cloneTracker = cloneTracker;

var trackOptView = function trackOptView(usageTracker, name) {
  usageTracker.standard.track(OPTIN_VIEW, {
    name: name
  });
};

exports.trackOptView = trackOptView;

var trackOptAction = function trackOptAction(usageTracker, name, choice) {
  usageTracker.immediate.track(OPTIN_INTERACTION, {
    name: name,
    action: ACTIONS[choice]
  });
};

exports.trackOptAction = trackOptAction;

var trackLearnMoreClick = function trackLearnMoreClick(usageTracker, name) {
  usageTracker.standard.track(OPTIN_INTERACTION, {
    name: name,
    action: ACTIONS[LEARN_MORE_CLICK]
  });
};

exports.trackLearnMoreClick = trackLearnMoreClick;

var trackFeedbackSurveyClick = function trackFeedbackSurveyClick(usageTracker, name) {
  usageTracker.standard.track(OPTIN_INTERACTION, {
    name: name,
    action: ACTIONS[FEEDBACK_PROVIDED]
  });
};

exports.trackFeedbackSurveyClick = trackFeedbackSurveyClick;